export const getLogoSpinnerUrl = (gold: boolean) =>
	`/ico/spinner.svg${gold ? "#gold" : ""}`;
